import applicationStore from '@/store/modules/applications/applicationStore';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ApplicationInformation from '@/components/familyPortal/manageApplications/applicationInformation/ApplicationInformation.vue';
import DropdownList from '@/ui-components/dropdownList/DropdownList.vue';
import AlreadySubmittedSite from '@/components/familyPortal/popupComponents/alreadySubmittedSite/AlreadySubmittedSite.vue';
import UIkit from 'uikit';
import formsStore from '@/store/modules/forms/formsStore';
import cart from '@/store/modules/checkout/cart/module';
import AccountSettings from '@/mixins/accountSettings.mixin';
import { ScreenText } from '@/lang/ScreenText';
import { Scholar } from '@/Model/enrollment/types';
import { DuplicateApplicationErrorType } from '@/Model/application/types';
import { doScholarsMatch } from '@/services/checkout/cart/helpers';

@Component({
  components: {
    'application-info': ApplicationInformation,
    'dropdown': DropdownList,
    'already-submitted-site': AlreadySubmittedSite
  }
})
export default class SelectScholar extends Mixins(AccountSettings) {
  @Prop({ type: Boolean, default: false }) readonly isCheckout!: boolean;

  public readonly screenText = new ScreenText();
  public selectedChild: Scholar | null = null;
  public selectedChildSiteIds: any = [];
  public scholarGuid: string = '';

  get childrenDropdown() {
    return applicationStore.childrenDropdownObj;
  }

  get selectedChildData() {
    return applicationStore.selectedChildData;
  }

  get nextArrow() {
    return this.selectedChildData.id == 0
      ? 'arrow-right-disable'
      : 'arrow-right';
  }

  get disabledButton() {
    return this.selectedChildData.id == 0
      ? true
      : false;
  }

  get siteList() {
    return applicationStore.sitesList;
  }

  /* istanbul ignore next */
  get applicationData() {
    return applicationStore.applicationDataInfo;
  }

  selectChild(child: any) {
    const modifiedChild = { ...child, birthDate: child.DOB };
    delete modifiedChild.DOB;
    this.selectedChild = modifiedChild;
    this.selectedChildSiteIds = [];
    localStorage.removeItem('scholar_guid');
    if (child.id == -1) {
      formsStore.SET_SHOULD_DISABLE_FORM_FIELDS_FALSE();
    }
    else {
      if (child.id) {
        this.selectedChildSiteIds = child.siteIds;
        localStorage.setItem('scholar_guid', child.id.toString());
      }
      formsStore.SET_SHOULD_DISABLE_FORM_FIELDS_TRUE();
    }
    applicationStore.mutateSelectedChild(child);
    formsStore.resetApplication();
    formsStore.updateScholarData({});
    this.$emit('onSelectChild', child);
  }

  next() {
    const scholarAlreadyApplied = this.alertIfScholarAlreadyApplied();
    if (scholarAlreadyApplied) {
      return;
    }
    formsStore.resetApplication();
    if (localStorage.scholar_guid != '-1') {
      localStorage.setItem('scholar_selected', JSON.stringify(true));
      this.autoFillTempScholar();
      if (localStorage.scholar_guid) {
        formsStore.getScholarData(localStorage.scholar_guid);
      }
    }
    else {
      localStorage.setItem('scholar_selected', JSON.stringify(false));
    }
    this.$emit('onScholarSelection', scholarAlreadyApplied);
  }

  alertIfScholarAlreadyApplied(): boolean {
    const scholarAlreadyHasSubmittedApplication = !!cart.currentlySelectedCartApplication && this.selectedChildSiteIds.includes(cart.currentlySelectedCartApplication.sessionId);
    const scholarAlreadyHasInProgressApplication = cart.cartApplications &&
      cart.cartApplications.cartItemApplicationData.some((x, index) =>
        x.applicationInProgress &&
        x.applicationInProgress.scholardob &&
        this.selectedChild &&
        doScholarsMatch(this.selectedChild, {
          firstName: x.applicationInProgress.scholar.scholar_firstname,
          lastName: x.applicationInProgress.scholar.scholar_lastname,
          birthDate: x.applicationInProgress.scholardob
        } as Scholar) &&
        cart.currentlySelectedCartApplication &&
        x.sessionId === cart.currentlySelectedCartApplication.sessionId &&
        index !== cart.currentlySelectedApplicationIndex
      );

    const scholarAlreadyApplied = scholarAlreadyHasSubmittedApplication || scholarAlreadyHasInProgressApplication;
    if (scholarAlreadyApplied) {
      if (scholarAlreadyHasSubmittedApplication) {
        applicationStore.SET_DUPLICATE_APPLICATION_ERROR_TYPE(DuplicateApplicationErrorType.Completed);
      }
      else if (scholarAlreadyHasInProgressApplication) {
        applicationStore.SET_DUPLICATE_APPLICATION_ERROR_TYPE(DuplicateApplicationErrorType.InProgress);
      }
      this.$emit('errorAlreadySubmittedSite');
      return true;
    }
    return false;
  }

  autoFillTempScholar() {
    if (applicationStore.selectedChild.id || !applicationStore.allSelectedChildData) {
      return;
    }
    const tempScholarData = applicationStore.allSelectedChildData;
    const payload = {
      scholar: {
        scholarName: {
          scholar_FirstName: tempScholarData.firstName,
          scholar_LastName: tempScholarData.lastName
        },
        scholarBirthDateField: {
          scholar_BirthDate: tempScholarData.DOB
        }
      }
    };

    formsStore.updateScholarData(payload);
  }

  previous() {
    //Currently unused in existing Checkout workflow
  }

  destroyed() {
    if (UIkit.modal('#modal-already-submitted')) {
      UIkit.modal('#modal-already-submitted').$destroy(true);
    }
  }
}